import React from 'react';
import { RecurringCard } from '../RecurringItem/RecurringItem.style';
import { Grid } from '@mui/material';
import PONumberIncrementorFields from './PONumberIncrementorField';

export default function AutoIncrementorOptionsCard({ item, setItem, disabled }) {
    return (
        <RecurringCard title={'Auto Increment Options'}>
            <Grid spacing={2} container="container">
                <PONumberIncrementorFields item={item} setItem={setItem} />
            </Grid>
        </RecurringCard>
    );
}
